export default {
  html: {
    fontSize: '14px',
  },
  body: {
    fontSize: '14px',
    bg: 'gray.50',
    color: 'gray.700',
  },
  a: {
    color: 'teal.500',
    _hover: {
      textDecoration: 'underline',
    },
  },
};
